import React, {Component} from "react";
import {connect} from "react-redux";
import {monthFilterStyle} from "../../../services/utils";
import ReactSelect, {components} from "react-select";
import {
  setEventStatsEndMonth,
  setEventStatsEndOptions,
  setEventStatsStartMonth, setMonthMenus
} from "../../../actions/actions/eventStats";


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} />
    </components.DropdownIndicator>
  );
};

const yearsOptions = [
  { value: 1, label: 'JANVIER'},
  { value: 2, label: 'FEVRIER' },
  { value: 3, label: 'MARS' },
  { value: 4, label: 'AVRIL' },
  { value: 5, label: 'MAI' },
  { value: 6, label: 'JUIN' },
  { value: 7, label: 'JUILLET' },
  { value: 8, label: 'AOUT' },
  { value: 9, label: 'SEPTEMBRE' },
  { value: 10, label: 'OCTOBRE' },
  { value: 11, label: 'NOVEMBRE' },
  { value: 12, label: 'DECEMBRE' },
];

class StartMonthFilter extends Component {

  handleSelectChange = (value) => {
    this.props.setEventStatsStartMonth(value);
    if(value.value > this.props.eventStatsFilter.endMonth){
      this.props.setEventStatsEndMonth({ value: 12, label: 'DECEMBRE' });
    }
    const filteredOptions = yearsOptions.filter(option => option.value >= value.value);
    this.props.setEventStatsEndOptions(filteredOptions);
  }

  openMenu = () => {
    this.props.setMonthMenus({startMonthMenuOpen: !this.props.eventStatsFilter.startMonthMenuOpen, endMonthMenuOpen: false});
  }

  render() {

    return (
      <div onClick={() => this.openMenu()}>
        <ReactSelect
          className="my-2 mx-4 event-small-filter"
          onChange={this.handleSelectChange}
          styles={monthFilterStyle()}
          defaultValue={{ value: this.props.eventStatsFilter.startMonth, label: this.props.eventStatsFilter.startMonthLabel}}
          options={this.props.eventStatsFilter.startOptions}
          components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
          menuIsOpen={this.props.eventStatsFilter.startMonthMenuOpen}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  setEventStatsStartMonth,
  setEventStatsEndOptions,
  setEventStatsEndMonth,
  setMonthMenus,
};

export default connect(mapStateToProps, mapDispatchToProps)(StartMonthFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/StartMonthFilter.js